module.exports = __webpack_public_path__ + "static/img/pay-stylepic6.8655a71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/pay-stylepic6.jpg
// module id = c4u7
// module chunks = 171